import React                from "react";
import Action               from "Dashboard/Core/Action";
import Navigate             from "Dashboard/Core/Navigate";
import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import useList              from "Dashboard/Hooks/List";

// Components
import MemberEdit           from "./MemberEdit";

// Dashboard
import Main                 from "Dashboard/Components/Core/Main";
import Content              from "Dashboard/Components/Core/Content";
import Header               from "Dashboard/Components/Header/Header";
import ActionList           from "Dashboard/Components/Header/ActionList";
import Table                from "Dashboard/Components/Table/Table";
import TableHead            from "Dashboard/Components/Table/TableHead";
import TableBody            from "Dashboard/Components/Table/TableBody";
import TableRow             from "Dashboard/Components/Table/TableRow";
import TableHeader          from "Dashboard/Components/Table/TableHeader";
import TableCell            from "Dashboard/Components/Table/TableCell";
import TablePaging          from "Dashboard/Components/Table/TablePaging";
import TableActionList      from "Dashboard/Components/Table/TableActionList";
import TableAction          from "Dashboard/Components/Table/TableAction";
import DeleteDialog         from "Dashboard/Components/Dialogs/DeleteDialog";



/**
 * The Training Member List
 * @returns {React.ReactElement}
 */
function MemberList() {
    const { fetch, load } = useList("trainingMember", "TRAINING_WHITE_LIST");

    const { trainingWhiteListID } = Navigate.useParams();
    const parent = Navigate.useParent(1);

    const data = Store.useState("trainingMember");
    const { loading, canEdit, list, total, whiteList, sort } = data;

    const { deleteElem } = Store.useAction("trainingMember");

    // The Current State
    const [ action, elemID, startAction, endAction ] = Action.useActionID();


    // Handles the Edit Submit
    const handleEdit = () => {
        endAction();
        fetch();
    };

    // Handles the Delete Submit
    const handleDelete = async () => {
        endAction();
        const result = await deleteElem(elemID);
        if (result.success) {
            fetch();
        }
    };


    // Do the Render
    const elemName = Utils.getValue(list, "trainingMemberID", elemID, "memberName");

    return <Main>
        <Header
            message={whiteList.name || "TRAININGS_MEMBERS_NAME"}
            icon="whiteList"
            href={parent}
            subTitle={whiteList.statusName}
            subCircle={whiteList.statusColor}
        >
            <ActionList data={data} onAction={startAction} useAdd />
        </Header>
        <Content>
            <Table
                fetch={load}
                sort={sort}
                none="TRAININGS_MEMBERS_NONE_AVAILABLE"
                isLoading={loading}
                hasTabs
            >
                <TableHead>
                    <TableHeader field="memberNumber" message="GENERAL_MEMBER_NUMBER" maxWidth="120" />
                    <TableHeader field="firstName"    message="GENERAL_NAME"          isTitle bigMobile />
                    <TableHeader field="description"  message="GENERAL_DESCRIPTION"   />
                    <TableHeader field="status"       message="GENERAL_STATUS"        maxWidth="100" align="center" />
                </TableHead>
                <TableBody>
                    {list.map((elem) => <TableRow key={elem.trainingMemberID} elemID={elem.trainingMemberID}>
                        <TableCell message={elem.memberNumber} />
                        <TableCell message={elem.memberName}   />
                        <TableCell message={elem.description}  />
                        <TableCell message={elem.statusName}   textColor={elem.statusColor} />
                    </TableRow>)}
                </TableBody>
                <TablePaging total={total} />
                <TableActionList onAction={startAction} canEdit={canEdit}>
                    <TableAction action="EDIT"   message="TRAININGS_MEMBERS_EDIT_TITLE"   />
                    <TableAction action="DELETE" message="TRAININGS_MEMBERS_DELETE_TITLE" />
                </TableActionList>
            </Table>
        </Content>

        <MemberEdit
            open={action.isVCE}
            elemID={elemID}
            trainingWhiteListID={trainingWhiteListID}
            onSubmit={handleEdit}
            onClose={endAction}
        />
        <DeleteDialog
            open={action.isDelete}
            title="TRAININGS_MEMBERS_DELETE_TITLE"
            message="TRAININGS_MEMBERS_DELETE_TEXT"
            content={elemName}
            onSubmit={handleDelete}
            onClose={endAction}
        />
    </Main>;
}

export default MemberList;
